import { render, staticRenderFns } from "./KWMSLeafletMap.vue?vue&type=template&id=0b6dcd89&"
import script from "./KWMSLeafletMap.vue?vue&type=script&lang=js&"
export * from "./KWMSLeafletMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports